import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
function ts(d) { if (!d) return '—'; const m=Math.floor((Date.now()-new Date(d))/60000); return m<1?'just now':m<60?`${m}m ago`:m<1440?`${Math.floor(m/60)}h ago`:`${Math.floor(m/1440)}d ago`; }

const ACTION_TYPES = [
  { id:'reboot',       label:'Reboot',          icon:'🔄', desc:'Restart the device',           color:'#d97706', bg:'#fef3c7' },
  { id:'shutdown',     label:'Shutdown',         icon:'⏹', desc:'Power off the device',         color:'#dc2626', bg:'#fee2e2' },
  { id:'lock_screen',  label:'Lock Screen',      icon:'🔒', desc:'Lock the workstation',         color:'#7c3aed', bg:'#ede9fe' },
  { id:'log_off_user', label:'Log Off User',     icon:'👤', desc:'Force current user off',       color:'#0891b2', bg:'#cffafe' },
  { id:'run_command',  label:'Run Command',      icon:'⌨',  desc:'Execute a shell command',      color:'#1d4ed8', bg:'#dbeafe' },
  { id:'message',      label:'Send Message',     icon:'💬', desc:'Show popup on device screen',  color:'#16a34a', bg:'#dcfce7' },
];

const STATUS_META = {
  pending:   { color:'#d97706', bg:'#fef3c7', label:'Pending'   },
  sent:      { color:'#1d4ed8', bg:'#dbeafe', label:'Sent'      },
  running:   { color:'#7c3aed', bg:'#ede9fe', label:'Running'   },
  success:   { color:'#16a34a', bg:'#dcfce7', label:'Success'   },
  failed:    { color:'#dc2626', bg:'#fee2e2', label:'Failed'    },
  timeout:   { color:'#64748b', bg:'#f1f5f9', label:'Timeout'   },
  cancelled: { color:'#94a3b8', bg:'#f8fafc', label:'Cancelled' },
};

export default function RemoteActions({ user }) {
  const [devices,   setDevices]   = useState([]);
  const [actions,   setActions]   = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [msg,       setMsg]       = useState({ text:'', type:'' });
  const [modal,     setModal]     = useState(null); // { type, devices, payload }
  const [selDevs,   setSelDevs]   = useState([]);
  const [command,   setCommand]   = useState('');
  const [msgTitle,  setMsgTitle]  = useState('IT Notice');
  const [msgBody,   setMsgBody]   = useState('');
  const [delay,     setDelay]     = useState(0);
  const [sending,   setSending]   = useState(false);
  const [refresh,   setRefresh]   = useState(0);

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }

  const load = useCallback(async () => {
    try {
      const [devRes, actRes] = await Promise.all([
        axios.get('/api/agents', auth()),
        axios.get('/api/remote-actions?limit=100', auth()),
      ]);
      setDevices(devRes.data.filter ? devRes.data.filter(d=>!d.archivedAt) : devRes.data);
      setActions(actRes.data);
    } catch(e) { flash(e.response?.data?.error||'Failed to load','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load, refresh]);
  // Auto-refresh every 15s for live status
  useEffect(() => { const t = setInterval(()=>setRefresh(r=>r+1), 15000); return ()=>clearInterval(t); }, []);

  async function dispatch() {
    if (!selDevs.length) return flash('Select at least one device','error');
    const type = modal;
    let payload = {};
    if (type === 'reboot' || type === 'shutdown') payload = { delay: parseInt(delay)||0 };
    if (type === 'run_command') { if (!command.trim()) return flash('Enter a command','error'); payload = { command: command.trim() }; }
    if (type === 'message') { if (!msgBody.trim()) return flash('Enter a message','error'); payload = { title: msgTitle, body: msgBody }; }
    setSending(true);
    try {
      const r = await axios.post('/api/remote-actions', { deviceIds: selDevs, type, payload }, auth());
      flash(`${r.data.queued} action(s) queued successfully`);
      setModal(null); setSelDevs([]); setCommand(''); setMsgBody(''); setDelay(0);
      setRefresh(r=>r+1);
    } catch(e) { flash(e.response?.data?.error||'Failed to queue action','error'); }
    finally { setSending(false); }
  }

  async function cancel(id) {
    try { await axios.delete(`/api/remote-actions/${id}`, auth()); flash('Action cancelled'); setRefresh(r=>r+1); }
    catch(e) { flash('Failed to cancel','error'); }
  }

  const onlineDevs  = devices.filter(d=>d.status==='online');
  const recentActs  = actions.slice(0,50);

  return (
    <div style={{padding:'24px'}}>
      {msg.text && <div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}

      <div style={{marginBottom:24}}>
        <h2 style={{margin:0,fontSize:20,fontWeight:700,color:'#1e293b'}}>Remote Actions</h2>
        <p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Execute actions on endpoints instantly — reboot, shutdown, lock, run commands</p>
      </div>

      {/* Action buttons */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))',gap:12,marginBottom:28}}>
        {ACTION_TYPES.map(a=>(
          <button key={a.id} onClick={()=>{setModal(a.id);setSelDevs([]);}} style={{background:a.bg,border:`2px solid ${a.color}20`,borderRadius:12,padding:'16px',textAlign:'left',cursor:'pointer',transition:'transform 0.1s'}}>
            <div style={{fontSize:26,marginBottom:6}}>{a.icon}</div>
            <div style={{fontWeight:700,fontSize:14,color:a.color}}>{a.label}</div>
            <div style={{fontSize:11,color:'#64748b',marginTop:2}}>{a.desc}</div>
          </button>
        ))}
      </div>

      {/* Recent actions */}
      <div style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,overflow:'hidden'}}>
        <div style={{padding:'14px 20px',borderBottom:'1px solid #f1f5f9',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <span style={{fontWeight:700,fontSize:15,color:'#1e293b'}}>Recent Actions</span>
          <button onClick={()=>setRefresh(r=>r+1)} style={{background:'none',border:'1px solid #e2e8f0',borderRadius:6,padding:'5px 10px',cursor:'pointer',fontSize:12,color:'#64748b'}}>↻ Refresh</button>
        </div>
        {loading ? <div style={{padding:32,textAlign:'center',color:'#94a3b8'}}>Loading...</div> : recentActs.length===0 ? (
          <div style={{padding:40,textAlign:'center',color:'#94a3b8',fontSize:14}}>No actions yet — select an action above to get started</div>
        ) : (
          <table style={{width:'100%',borderCollapse:'collapse'}}>
            <thead><tr style={{background:'#f8fafc'}}>
              {['Device','Action','Status','Triggered By','Time','Output',''].map(h=>(
                <th key={h} style={{padding:'10px 16px',textAlign:'left',fontSize:12,fontWeight:700,color:'#64748b',borderBottom:'1px solid #f1f5f9'}}>{h}</th>
              ))}
            </tr></thead>
            <tbody>
              {recentActs.map(a=>{
                const sm = STATUS_META[a.status]||{color:'#64748b',bg:'#f1f5f9',label:a.status};
                const at = ACTION_TYPES.find(x=>x.id===a.type)||{icon:'⚡',label:a.type};
                return (
                  <tr key={a.id} style={{borderBottom:'1px solid #f8fafc'}}>
                    <td style={{padding:'10px 16px',fontSize:13,fontWeight:600,color:'#1e293b'}}>{a.device?.hostname||'—'}</td>
                    <td style={{padding:'10px 16px',fontSize:13}}><span style={{marginRight:6}}>{at.icon}</span>{at.label}</td>
                    <td style={{padding:'10px 16px'}}>
                      <span style={{background:sm.bg,color:sm.color,borderRadius:6,padding:'2px 8px',fontSize:11,fontWeight:700}}>{sm.label}</span>
                    </td>
                    <td style={{padding:'10px 16px',fontSize:12,color:'#64748b'}}>{a.triggeredBy||'—'}</td>
                    <td style={{padding:'10px 16px',fontSize:12,color:'#94a3b8'}}>{ts(a.createdAt)}</td>
                    <td style={{padding:'10px 16px',fontSize:11,color:'#64748b',maxWidth:200,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                      {a.output||a.error||'—'}
                    </td>
                    <td style={{padding:'10px 16px'}}>
                      {a.status==='pending' && <button onClick={()=>cancel(a.id)} style={{background:'#fee2e2',border:'none',borderRadius:5,padding:'3px 8px',fontSize:11,cursor:'pointer',color:'#dc2626'}}>Cancel</button>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {/* Action modal */}
      {modal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:520,maxWidth:'95vw',maxHeight:'85vh',overflow:'auto'}}>
            {(() => {
              const at = ACTION_TYPES.find(a=>a.id===modal)||{icon:'⚡',label:modal,color:'#1d4ed8',bg:'#dbeafe'};
              return (
                <>
                  <h3 style={{margin:'0 0 4px',fontSize:18,fontWeight:700}}>{at.icon} {at.label}</h3>
                  <p style={{margin:'0 0 20px',color:'#64748b',fontSize:13}}>{at.desc}</p>

                  {/* Device selection */}
                  <div style={{marginBottom:16}}>
                    <div style={{fontWeight:600,fontSize:13,marginBottom:8,color:'#374151'}}>
                      Target Devices <span style={{color:'#94a3b8',fontWeight:400}}>({onlineDevs.length} online)</span>
                    </div>
                    <div style={{display:'flex',gap:8,marginBottom:8}}>
                      <button onClick={()=>setSelDevs(onlineDevs.map(d=>d.id))} style={{fontSize:11,padding:'4px 10px',background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:5,cursor:'pointer'}}>Select All Online</button>
                      <button onClick={()=>setSelDevs([])} style={{fontSize:11,padding:'4px 10px',background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:5,cursor:'pointer'}}>Clear</button>
                    </div>
                    <div style={{maxHeight:160,overflow:'auto',border:'1px solid #e2e8f0',borderRadius:8}}>
                      {devices.filter(d=>!d.archivedAt).map(d=>(
                        <label key={d.id} style={{display:'flex',alignItems:'center',gap:10,padding:'8px 12px',borderBottom:'1px solid #f8fafc',cursor:'pointer',background:selDevs.includes(d.id)?'#eff6ff':'#fff'}}>
                          <input type="checkbox" checked={selDevs.includes(d.id)} onChange={e=>setSelDevs(s=>e.target.checked?[...s,d.id]:s.filter(x=>x!==d.id))} />
                          <span style={{flex:1,fontSize:13,fontWeight:500,color:'#1e293b'}}>{d.hostname}</span>
                          <span style={{fontSize:11,color:d.status==='online'?'#16a34a':'#94a3b8',fontWeight:600}}>{d.status==='online'?'● Online':'○ Offline'}</span>
                        </label>
                      ))}
                    </div>
                    {selDevs.length>0 && <div style={{fontSize:12,color:'#1d4ed8',marginTop:4,fontWeight:600}}>{selDevs.length} device(s) selected</div>}
                  </div>

                  {/* Type-specific options */}
                  {(modal==='reboot'||modal==='shutdown') && (
                    <div style={{marginBottom:16}}>
                      <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4,color:'#374151'}}>Delay (seconds)</label>
                      <input type="number" value={delay} onChange={e=>setDelay(e.target.value)} min="0" max="3600" style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />
                      <div style={{fontSize:11,color:'#64748b',marginTop:4}}>0 = immediately, 60 = 1 minute delay</div>
                    </div>
                  )}
                  {modal==='run_command' && (
                    <div style={{marginBottom:16}}>
                      <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4,color:'#374151'}}>Command</label>
                      <input value={command} onChange={e=>setCommand(e.target.value)} placeholder="e.g. ipconfig /all" style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,fontFamily:'monospace',boxSizing:'border-box'}} />
                    </div>
                  )}
                  {modal==='message' && (
                    <>
                      <div style={{marginBottom:12}}>
                        <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4,color:'#374151'}}>Title</label>
                        <input value={msgTitle} onChange={e=>setMsgTitle(e.target.value)} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />
                      </div>
                      <div style={{marginBottom:16}}>
                        <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4,color:'#374151'}}>Message</label>
                        <textarea value={msgBody} onChange={e=>setMsgBody(e.target.value)} rows={3} placeholder="System will restart in 10 minutes for maintenance." style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box',resize:'vertical'}} />
                      </div>
                    </>
                  )}

                  <div style={{display:'flex',gap:10,justifyContent:'flex-end',marginTop:4}}>
                    <button onClick={()=>setModal(null)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                    <button onClick={dispatch} disabled={sending||!selDevs.length} style={{padding:'10px 20px',background:sending?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:sending?'default':'pointer'}}>
                      {sending ? 'Sending...' : `Send ${at.label}`}
                    </button>
                  </div>
                </>
              );
            })()}
          </div>
        </div>
      )}
    </div>
  );
}
